import React from 'react'
import { styled, Label, MutedText, getLocalizedProperty, context } from '@tools/wr-catalog-base'

const Content = styled.div`
  font: 12pt 'Calibri', 'Candara', 'Segoe', 'Segoe UI', 'Optima', 'Arial', sans-serif;

  ul,
  ol {
    padding-left: 40px;
  }
  ul ul {
    li {
      list-style-type: circle;
    }
    ul {
      li {
        list-style-type: square;
      }
    }
  }

  table td {
    padding: 0.4rem;
  }
`

const fixLocalLinks = (container) => {
  // This should work on any env
  const origins = ['https://ptc-internal.workrails.com', window.location.origin]

  Array.from(container.querySelectorAll('a')).forEach((link) => {
    const url = link.href || ''
    if (origins.some((org) => url.startsWith(org))) {
      link.addEventListener('click', (e) => {
        e.preventDefault()
        const localUrl = origins.reduce((str, org) => str.replace(org, ''), url)
        context.history.push(localUrl)
      })
    }
  })
}

const HTMLComponent = ({ row }) => {
  const divRef = React.useRef(null)
  React.useEffect(() => {
    fixLocalLinks(divRef.current)
  }, [])

  const HTMLcontent = getLocalizedProperty(row, 'control')

  const helpText = HTMLcontent && row.description

  return (
    <div ref={divRef}>
      <Label>{getLocalizedProperty(row, 'label')}</Label>
      {helpText && <MutedText>{helpText}</MutedText>}
      <Content dangerouslySetInnerHTML={{ __html: HTMLcontent }} />
    </div>
  )
}

export default HTMLComponent
